// ── Cliente Supabase ─────────────────────────────────────────────────────────
// Instância única compartilhada por todo o app (import ES = singleton).
import { createClient } from "@supabase/supabase-js";

export const SUPABASE_URL  = "https://wmzhslktcsuqsfpblcva.supabase.co";
export const SUPABASE_ANON = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6IndtemhzbGt0Y3N1cXNmcGJsY3ZhIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzI4OTIyNjgsImV4cCI6MjA4ODQ2ODI2OH0.6aAnS6kEqKl8jblt5tAdOfM6agiAZeLCQskhDoWcfE8";
export const sb = createClient(SUPABASE_URL, SUPABASE_ANON);

// Cliente separado para conferir senha SEM trocar a sessão atual (não persiste nada).
// Assim, quem usa verificação em duas etapas não perde a sessão já verificada.
export function makeCheckClient() {
  return createClient(SUPABASE_URL, SUPABASE_ANON, { auth: { persistSession: false, autoRefreshToken: false, detectSessionInUrl: false, storageKey: "g17-check" } });
}
